module.exports = __webpack_public_path__ + "img/ET.e505b2a4.svg";